import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import * as React from 'react';
import Icon from '../icon';
import Button from '../button';
import { getCompProps } from '../_utils';
import { ConfigContext } from '../config-provider';
import usePopper from '../_utils/usePopper';
var Popconfirm = function Popconfirm(props) {
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    pkgPrefixCls = _React$useContext.prefixCls,
    userDefaultProps = _React$useContext.compDefaultProps,
    locale = _React$useContext.locale;
  // 属性需要合并一遍用户定义的默认属性
  var allProps = getCompProps('Popconfirm', userDefaultProps, props);
  var icon = allProps.icon,
    title = allProps.title,
    okText = allProps.okText,
    okType = allProps.okType,
    message = allProps.message,
    children = allProps.children,
    onCancel = allProps.onCancel,
    onConfirm = allProps.onConfirm,
    cancelText = allProps.cancelText,
    okButtonProps = allProps.okButtonProps,
    defaultVisible = allProps.defaultVisible,
    onVisibleChange = allProps.onVisibleChange,
    cancelButtonProps = allProps.cancelButtonProps,
    customPrefixcls = allProps.prefixCls;
  // className前缀
  var prefixCls = getPrefixCls(pkgPrefixCls, 'popconfirm', customPrefixcls);
  var _React$useState = React.useState(!!props.visible || defaultVisible),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    visible = _React$useState2[0],
    setVisible = _React$useState2[1];
  React.useEffect(function () {
    setVisible(!!props.visible);
  }, [props.visible]);
  var confirmLocator = React.Children.count(children) === 1 && children.type ? children : /*#__PURE__*/React.createElement("span", null, children);
  var confirmTitle = typeof title === 'function' ? title() : title;
  var confirmMsg = typeof title === 'function' ? message() : message;
  var handleCancel = function handleCancel(e) {
    props.visible === undefined && setVisible(false);
    onVisibleChange && onVisibleChange(false);
    onCancel && onCancel(e);
  };
  var handleConfirm = function handleConfirm(e) {
    props.visible === undefined && setVisible(false);
    onVisibleChange && onVisibleChange(false);
    onConfirm && onConfirm(e);
  };
  var confirmPopper = /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-content")
  }, confirmTitle && /*#__PURE__*/React.createElement("h3", {
    className: "".concat(prefixCls, "-title")
  }, 'icon' in props ? icon === true ? /*#__PURE__*/React.createElement(Icon, {
    type: "warning-solid"
  }) : icon : null, confirmTitle), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-message")
  }, confirmMsg), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-interaction")
  }, /*#__PURE__*/React.createElement(Button, _extends({}, cancelButtonProps, {
    onClick: handleCancel
  }), cancelText || locale.getLangMsg('Popconfirm', 'cancel')), /*#__PURE__*/React.createElement(Button, _extends({}, okButtonProps, {
    type: okType,
    onClick: handleConfirm
  }), okText || locale.getLangMsg('Popconfirm', 'confirm'))));
  var handleVisibleChange = function handleVisibleChange(visible) {
    props.visible === undefined && setVisible(visible);
    onVisibleChange && onVisibleChange(visible);
  };
  var popperProps = _extends(_extends({}, allProps), {
    visible: visible,
    prefixCls: prefixCls,
    arrow: true,
    onVisibleChange: handleVisibleChange
  });
  return usePopper(confirmLocator, confirmPopper, popperProps);
};
Popconfirm.displayName = 'Popconfirm';
export default Popconfirm;